/* HMX V23 — selected-variant savings amount. */
(() => {
  'use strict';

  if (window.__HMX_SAVE_AMOUNT_CTA_MOTION_V23__) return;
  window.__HMX_SAVE_AMOUNT_CTA_MOTION_V23__ = true;

  const formatSavings = (cents) => {
    const value = Math.max(0, Number(cents || 0));
    const currency = window.Shopify?.currency?.active || 'USD';
    const wholeAmount = value % 100 === 0;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: wholeAmount ? 0 : 2,
        maximumFractionDigits: wholeAmount ? 0 : 2
      }).format(value / 100);
    } catch (_) {
      return `$${(value / 100).toFixed(wholeAmount ? 0 : 2)}`;
    }
  };

  const readVariants = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-hmx-variants]')?.textContent || '[]');
    } catch (_) {
      return [];
    }
  };

  const selectedVariant = (root) => {
    const variants = readVariants(root);
    const variantId = root.querySelector('[data-hmx-variant-id]')?.value;
    if (variantId) {
      const byId = variants.find((variant) => String(variant.id) === String(variantId));
      if (byId) return byId;
    }

    const selected = [...root.querySelectorAll('[data-hmx-option]')].map((select) => select.value);
    return variants.find((variant) =>
      Array.isArray(variant.options) && variant.options.every((value, index) => value === selected[index])
    ) || null;
  };

  const updateSavings = (root, suppliedVariant = null) => {
    if (!root) return;
    const badge = root.querySelector('[data-hmx-sale-badge]');
    const variant = suppliedVariant || selectedVariant(root);

    if (badge && variant) {
      const price = Number(variant.price || 0);
      const compareAt = Number(variant.compare_at_price || 0);
      const savings = Math.max(0, compareAt - price);

      if (compareAt > price && savings > 0) {
        const formatted = formatSavings(savings);
        badge.textContent = `SAVE ${formatted}`;
        badge.hidden = false;
        badge.setAttribute('aria-label', `Save ${formatted}`);
      } else {
        badge.hidden = true;
        badge.removeAttribute('aria-label');
      }
    }

    root.dataset.hmxV23SavingsReady = 'true';
  };

  const initRoot = (root) => {
    if (!root || root.dataset.hmxV23SavingsBound === 'true') return;
    root.dataset.hmxV23SavingsBound = 'true';

    updateSavings(root);

    root.addEventListener('hmx:variant-change', (event) => {
      updateSavings(root, event.detail?.variant || null);
    });

    root.querySelectorAll('[data-hmx-option]').forEach((select) => {
      select.addEventListener('change', () => window.setTimeout(() => updateSavings(root), 0));
    });
  };

  const boot = (scope = document) => {
    if (scope?.matches?.('[data-hmx-wallet-v2]')) initRoot(scope);
    scope?.querySelectorAll?.('[data-hmx-wallet-v2]').forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
